import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { SignInPassword } from "@/features/auth/sign-in-password";

export const Route = createFileRoute("/(auth)/sign-in-password")({
  component: SignInPasswordPage,
  validateSearch: z.object({
    method: z.enum(["phone", "email"]).default("email"),
    identifier: z.string().optional(),
    factorId: z.string().optional(),
    redirect_url: z.string().optional(),
  }),
});

function SignInPasswordPage() {
  return (
    <PublicLayout>
      <ResponsiveWrapper
        className={cn(
          /* sorted */
          "grow",
          "py-12",
          "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
        )}
      >
        <SignInPassword />
      </ResponsiveWrapper>
    </PublicLayout>
  );
}
